import { Tooltip } from "@mui/material";

import styles from "./styles.module.scss";

interface ButtonEditedProps {
  handleEditeItem: () => void;
}

export function ButtonEdited({ handleEditeItem }: ButtonEditedProps) {
  return (
    <Tooltip title="Editar">
      <button
        type = "button"
        className={`${styles.buttonEdited}`}
        onClick={() => handleEditeItem()}
      ></button>
    </Tooltip>
  );
}